import refs from '../helpers/refs'
import './c-instruction-manual-category.js'
import './c-instruction-manual-search.js'

class CInstructionManuals {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)
    this.form = this.$root.querySelector('#searchForm')
    this.waitBlock = this.$root.querySelector('.please-wait')
    this.submitButton = this.$root.querySelector('.search-button')
    this.resultsDiv = document.querySelector('#searchResults')
    this.searchManuals = this.searchManuals.bind(this)
    this.form.addEventListener('submit', this.searchManuals)

    this.init()
  }

  init () {
  }

  async searchManuals (e) {
    // don't forget to put async back on this
    e.preventDefault()
    this.waitBlock?.classList.remove('hidden')
    this.submitButton.disabled = true

    const url = 'https://3mxotm9s45.execute-api.us-west-2.amazonaws.com/Prod/manuals'

    const formData = new FormData(this.form)

    const jsonData = {}
    formData.forEach((value, key) => {
      jsonData[key] = value
    })

    // console.log('search data', jsonData)
    if (!jsonData.sku) {
      this.resultsDiv.innerHTML = window.manualSearchStrings.no_search_term
      this.waitBlock?.classList.add('hidden')
      this.submitButton.disabled = false
      return
    }

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonData)
    })
    // console.log('response', response)

    if (!response.ok) {
      document.querySelector('.manual-search-num-results').innerText = window.manualSearchStrings.search_error
      this.waitBlock?.classList.add('hidden')
      this.submitButton.disabled = false
      throw new Error('Network response was not ok')
    }

    // Handle response data, if needed
    const data = await response.json()
    // console.log('num results', data.message.items.length)
    let numItemsFoundString = window.manualSearchStrings.num_results.replace('xx', data.message.items.length)
    if (data.message.items.length === 1) {
      numItemsFoundString = window.manualSearchStrings.one_result
    }
    document.querySelector('.manual-search-num-results').innerText = `${numItemsFoundString}`
    // console.log(data.message)
    if (data.message.items.length > 0) {
      let tableString = `<table><thead><tr><th>${window.manualSearchStrings.products}</th><th>${window.manualSearchStrings.models}</th><th>${window.manualSearchStrings.documents}</th></thead><tbody>`
      data.message.items.forEach((item) => {
        // add row
        tableString += `<tr><td>${item.product_name?.sort().join(', ')}</td><td>${item.model_no?.sort().join(', ')}</td><td><a href="${item.file_url}" target="_blank">${item.title} (PDF)</a></td></tr>`
      })
      tableString += '</tbody></table>'

      this.resultsDiv.innerHTML = tableString
    } else {
      this.resultsDiv.innerHTML = window.manualSearchStrings.no_results
    }

    this.waitBlock?.classList.add('hidden')
    this.submitButton.disabled = false
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-instruction-manuals')
    .forEach(el => new CInstructionManuals(el))
})
